import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { api, API_BASE } from '../../api/client';

interface Region {
  id: number;
  name: string;
}

export default function AdminRegionsPage() {
  const [regions, setRegions] = useState<Region[]>([]);
  const [newName, setNewName] = useState('');
  const [creating, setCreating] = useState(false);

  const load = () => axios.get(`${API_BASE}/regions`).then(r => setRegions(r.data));

  useEffect(() => { load(); }, []);

  const create = async (e: React.FormEvent) => {
    e.preventDefault();
    setCreating(true);
    try {
      await api.post('/regions', { name: newName });
      setNewName('');
      await load();
    } finally {
      setCreating(false);
    }
  };

  const remove = async (id: number) => {
    if (!window.confirm('Удалить регион?')) return;
    await api.delete(`/regions/${id}`);
    await load();
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.title}>Управление регионами</h2>

      {/* Создать */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>➕ Добавить регион</h3>
        <form onSubmit={create} style={styles.form}>
          <input
            style={styles.input}
            placeholder="Название региона (напр. Бишкек, Ош, Чуй...)"
            value={newName}
            onChange={e => setNewName(e.target.value)}
            required
          />
          <button style={styles.btn} type="submit" disabled={creating}>
            {creating ? 'Добавление...' : 'Добавить'}
          </button>
        </form>
      </div>

      {/* Список */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>Список регионов</h3>
        {regions.length === 0 ? (
          <p style={{ color: '#888', padding: '0 20px 20px' }}>Регионов пока нет</p>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.thead}>
                  <th style={styles.th}>ID</th>
                  <th style={styles.th}>Название</th>
                  <th style={styles.th}>Действия</th>
                </tr>
              </thead>
              <tbody>
                {regions.map(r => (
                  <tr key={r.id} style={styles.tr}>
                    <td style={styles.td}>{r.id}</td>
                    <td style={styles.td}>{r.name}</td>
                    <td style={styles.td}>
                      <button onClick={() => remove(r.id)} style={styles.btnDanger}>🗑 Удалить</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { padding: 'clamp(16px, 4vw, 32px)', maxWidth: 700, margin: '0 auto' },
  title: { color: '#1a3a6b', fontSize: 'clamp(1.3rem, 3vw, 1.6rem)', marginBottom: 'clamp(16px, 3vw, 24px)' },
  card: { background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.08)', marginBottom: 16, overflow: 'hidden' },
  cardTitle: { color: '#1a3a6b', fontSize: 'clamp(0.9rem, 2vw, 1rem)', padding: '16px 20px', borderBottom: '1px solid #f0f4fb' },
  form: { display: 'flex', gap: 10, padding: '16px 20px 20px', flexWrap: 'wrap' },
  input: { flex: 1, minWidth: 200, padding: '10px 14px', borderRadius: 8, border: '1px solid #dde3ef', fontSize: '0.95rem', outline: 'none' },
  btn: { padding: '10px 20px', background: '#1a3a6b', color: '#fff', border: 'none', borderRadius: 8, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' },
  tableWrapper: { overflowX: 'auto', width: '100%' },
  table: { width: '100%', borderCollapse: 'collapse', minWidth: 500 },
  thead: { background: '#f0f4fb' },
  th: { padding: '12px 20px', textAlign: 'left', fontSize: '0.85rem', color: '#555', fontWeight: 600, whiteSpace: 'nowrap' },
  tr: { borderTop: '1px solid #f0f4fb' },
  td: { padding: '12px 20px', fontSize: '0.9rem', color: '#333', whiteSpace: 'nowrap' },
  btnDanger: { padding: '5px 12px', background: '#e74c3c', color: '#fff', border: 'none', borderRadius: 6, fontSize: '0.82rem', cursor: 'pointer', whiteSpace: 'nowrap' },
};
